// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.event-detail-page {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: var(--space-4);
  min-height: 100%;
}

.event-detail-page__header {
  display: flex;
  align-items: center;
}

.event-detail-page__back {
  background: none;
  border: none;
  color: var(--color-fire-600);
  font-family: var(--font-body);
  font-size: var(--font-size-body);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  padding: var(--space-2) 0;
  transition: color var(--transition-fast);
}

.event-detail-page__back:hover {
  color: var(--color-fire-700);
}

.event-detail-page__content {
  flex: 1;
}

@media (min-width: 768px) {
  .event-detail-page {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/EventDetail/EventDetailPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,6BAA6B;EAC7B,gCAAgC;EAChC,wCAAwC;EACxC,eAAe;EACf,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;AACF","sourcesContent":[".event-detail-page {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-4);\n  padding: var(--space-4);\n  min-height: 100%;\n}\n\n.event-detail-page__header {\n  display: flex;\n  align-items: center;\n}\n\n.event-detail-page__back {\n  background: none;\n  border: none;\n  color: var(--color-fire-600);\n  font-family: var(--font-body);\n  font-size: var(--font-size-body);\n  font-weight: var(--font-weight-semibold);\n  cursor: pointer;\n  padding: var(--space-2) 0;\n  transition: color var(--transition-fast);\n}\n\n.event-detail-page__back:hover {\n  color: var(--color-fire-700);\n}\n\n.event-detail-page__content {\n  flex: 1;\n}\n\n@media (min-width: 768px) {\n  .event-detail-page {\n    width: 100%;\n    max-width: 800px;\n    margin: 0 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
